import instance from '../instance';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';
import { UPDATE_BOTH } from '../constants/update-strategies';

const updateAtomicCss = (stylesString, updateStrategy = UPDATE_BOTH) => {
  instance.driver.updateAtomicCSS(stylesString, updateStrategy);

  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);
  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default updateAtomicCss;
